import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'

import { useCampaignContestSearch } from '@pages/Traders-Room/Campaign-Results/Contest/hooks/useCampaignContestSearch'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { initialPageData, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useCampaignContestResultsFetch = (
  accountId: string | undefined,
  campaignId: string | undefined,
  search: ReturnType<typeof useCampaignContestSearch>
) => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const searchKey = {
    ...search.search,
    ...search.pageQuery,
    locale,
  }

  const query = usePaginatedQuery({
    queryKey: queryKeys.campaign.contestResults(accountId, campaignId, searchKey),
    queryFn: (pageQuery) => {
      if (!accountId || !campaignId) return Promise.resolve(initialPageData)
      return apiClient.getContestCampaignResults(accountId, campaignId, {
        ...pageQuery,
        ...search.pageQuery,
        search: search.search,
        caller: 'ca',
        languageId: locale,
      })
    },
    enabled: !!accountId && !!campaignId,
  })

  return query
}
